import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  constructor(private translate: TranslateService) {
    super();
    this.updateLabels();
    this.translate.onLangChange.subscribe(() => this.updateLabels());
  }

  updateLabels() {
    this.itemsPerPageLabel = this.translate.instant('pagination.ITEMS_PER_PAGE');
    this.nextPageLabel = this.translate.instant('pagination.NEXT_PAGE');
    this.previousPageLabel = this.translate.instant('pagination.PREVIOUS_PAGE');
    this.firstPageLabel = this.translate.instant('pagination.FIRST_PAGE');
    this.lastPageLabel = this.translate.instant('pagination.LAST_PAGE');
    this.changes.next();
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return this.translate.instant('pagination.NO_RESULTS');
    }
    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return `${startIndex + 1} - ${endIndex} ${this.translate.instant('pagination.OF')} ${length}`;
  };
}
